import { Component, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList, Input, ElementRef, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { ManageRolesContext } from '../../security/models/ManageRolesContext';
import { Action, Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import * as fromStore from '../../security/store/reducers';
import * as fromCustomerStore from '../../customer/store/reducers';
import * as actions from '../../security/store/actions';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as userActions from '../../customer/store/actions'
import { RoleModel } from '../../security/models/RoleModel';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { QueryAvailableRolesAction, QueryAvailableRolesByTypeAction, QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS, QUERY_AVAILABLE_ROLES_SUCCESS } from '../../security/store/actions';
import { ActionBase } from '../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../customer.module.config';
import { ActivatedRoute, Router } from '@angular/router';
import { UserModel } from '../models/UserModel';


@Component({
  selector: 'brd-manage-roles',
  templateUrl: './manage-roles.component.html',
  styleUrls: ['./manage-roles.component.scss']
})

export class ManageRolesComponent implements OnInit, OnDestroy {
  key: string;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  actionIdentifiers: string[] = [];
  loadingAvailable: boolean;
  availableRoles: RoleModel[];
  allRoles: RoleModel[] = [];
  allAssignedRoles: RoleModel[];
  assignedRoles$: Observable<RoleModel[]>;
  assignedRoles: RoleModel[];
  showDetailsForAvailable = true;
  showDetailsForAssigned = true;
  data: ManageRolesContext;
  user: UserModel;
  isPortal: boolean=true;

  @ViewChild(AlertsComponent)
  alert: AlertsComponent;

  @ViewChildren(SearchComponent)
  searchs: QueryList<SearchComponent>;
  
  constructor(public store: Store<any>,
    private action$: Actions,
    private route: ActivatedRoute,
    private currentUserService: CurrentUserService) {
    
      this.loadingAvailable = true;
  }

  storeDispatch(action : Action){
    var actionBase = action as ActionBase;
    if(actionBase) {
      this.actionIdentifiers.push(actionBase.identifier);
    }
    this.store.dispatch(action);
  }

  ngOnDestroy(): void {
    this.storeDispatch(new dashboardActions.ClearSelectionAction(ModuleConfiguration.moduleName, UserModel));
    this.destroyed$.next(true);
  }

  refreshUser(){
    if(this.key){
      this.storeDispatch(new dashboardActions.GetSelectionAction(ModuleConfiguration.moduleName, UserModel, { key: this.key }));
    }
  }
 
  ngOnInit() {
    this.route.params.take(1).subscribe(p => {
      this.key = p['key'];
      this.refreshUser();
    });

    this.route.queryParams.subscribe(qp => {
      var isPortalValue = qp['isPortal'];
      if (isPortalValue) {
        this.isPortal = isPortalValue;
        this.pollPostHeightToIFrameParent();
      }
    });

    this.action$.ofType(QUERY_AVAILABLE_ROLES_SUCCESS)
    .takeUntil(this.destroyed$)
    .subscribe(() => {
      this.loadingAvailable = false;
    });

    this.action$.ofType(QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS)
    .takeUntil(this.destroyed$)
    .subscribe(() => {
      this.loadingAvailable = false;
    });

    this.action$.ofType(actions.MANAGE_ROLE_ERROR)
    .takeUntil(this.destroyed$)
    .subscribe((a: actions.ManageRoleErrorAction) =>{
      a.payload.errors.forEach(e => this.alert.addError(e));
    });

    this.action$.ofType(userActions.ADD_ROLE_TO_USER_SUCCESS)
    .takeUntil(this.destroyed$)
    .subscribe(() => {
      this.loadingAvailable = false;
    });

    this.action$.ofType(userActions.REMOVE_ROLE_FROM_USER_SUCCESS)
    .takeUntil(this.destroyed$)
    .subscribe(() => {
      this.loadingAvailable = false;
    });

    this.store.select(fromStore.getAvailableRoles).takeUntil(this.destroyed$)
    .subscribe((roles: RoleModel[]) => {
      this.allRoles = roles;
      this.updateAvailableRoles();
    });

    this.assignedRoles$ = this.store.select(fromCustomerStore.getUserAssignedRoles);

    this.store.select(fromCustomerStore.getUserSelection)
    .takeUntil(this.destroyed$)
    .subscribe((v: UserModel) => {
      if (v) {
        this.user = v;   
        this.data = {
          assignedRoles$: this.assignedRoles$,
          addRole: (role) => {
            this.storeDispatch(new userActions.AddRoleToUserAction({ userKey : this.user.key, role: role}))
          },
          removeRole: (role) => {
            this.storeDispatch(new userActions.RemoveRoleFromUserAction({ userKey: this.user.key, role: role}));
          },
          loadIncludedRoles: (role) => { },
          accountName: this.user.identifier
        }
    
        if( !this.data.roleType){
          this.store.dispatch(new QueryAvailableRolesAction({
            page: 0,
            pageSize: 100
          }));
        }else{
          this.store.dispatch(new QueryAvailableRolesByTypeAction(this.data.roleType, {
            page: 0,
            pageSize: 100
          }));
        }
       
        this.data.assignedRoles$.takeUntil(this.destroyed$)
            .subscribe((roles: RoleModel[]) => {
            this.allAssignedRoles = roles;
            this.updateAssignedRoles(null);
            this.updateAvailableRoles();
          })
      }
    });
  }

  ngAfterViewInit() {
    
    this.searchs.first.searchControl.valueChanges
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loadingAvailable = true;
        this.store.dispatch(new QueryAvailableRolesAction({
          page: 0,
          pageSize: 100,
          searchTerm: this.searchs.first.searchControl.value
        }));
      });

    this.searchs.last.searchControl.valueChanges
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.updateAssignedRoles(this.searchs.last.searchControl.value);
      });
  }

  private updateAvailableRoles(): void {
    if(this.allRoles){
      this.availableRoles = this.allAssignedRoles ? this.allRoles
        .filter(r => this.allAssignedRoles.find( ar => ar.key === r.key) == null &&
        (this.data.forRole === undefined || this.data.forRole.key !== r.key)) : this.allRoles;
    } else {
      this.availableRoles = undefined;
    }
  }

  private updateAssignedRoles(searchTerm) {
    this.assignedRoles = searchTerm ? this.allAssignedRoles.filter(ar => ar.name.toLowerCase().includes(searchTerm.toLowerCase())) : this.allAssignedRoles;
  }

  removeTheRole(role): void {
    if(this.allAssignedRoles.length === 1 && this.currentUserService.userContext.userName === this.data.accountName) {
      this.alert.addError("Cannot remove all roles.")
    } else {
      this.data.removeRole(role);
    }
  }

  pollPostHeightToIFrameParent(height: number = undefined) {
    window.setTimeout(() => {
        var variableHeightElement = document.querySelector("brd-manage-roles");
        if (variableHeightElement) {
          var currentHeight = variableHeightElement.clientHeight;
          if (height != currentHeight) {
            height = currentHeight;
            this.postHeightToIframeParent(height);
          }
        }
        this.pollPostHeightToIFrameParent(height);
      },
      200);
  }

  postHeightToIframeParent(height: number) {
    window.parent.postMessage({ "height": height, }, "*");
  }

}



// WEBPACK FOOTER //
// ./src/app/customer/components/manage-roles.component.ts